<template>
    <div class="banner-background-area banner-background-area-bg bg-img section-space--ptb_120 bg-cover" :style="bgImg">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="saas-banner-background">
                        <div class="content-wrapper">
                            <h2 class="heading_title text-white font-weight--light wow move-up">Wanna see what all can Hedwig do?</h2>
                            <div class="banner__text mt-20 text-white wow move-up">The best way to find out is to try it </div>
                            <div class="saas-background__links section-space--mt_40 wow move-up">
                                <div onclick="location.href='https://app.gohedwig.in/auth/'" class="btn btn--green">
                                    <span class="btn-icon  ml-0 mr-2"></span> Try it now
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BannerBgOne',
        data () {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/bg/aeroland-sass-image-04.jpg')})`
                },
            }
        }
    };
</script>
